import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid credit-card" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexPaymentDetail',
  setup(__props) {

const CreditCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/CreditCard.vue"))
const DebitCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/DebitCard.vue"))
const CodCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/CodCard.vue"))
const EmiCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/EmiCard.vue"))
const NetBanking = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/NetBanking.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(CreditCard)),
      _createVNode(_unref(DebitCard)),
      _createVNode(_unref(CodCard)),
      _createVNode(_unref(EmiCard)),
      _createVNode(_unref(NetBanking))
    ])
  ]))
}
}

})